import { render, staticRenderFns } from "./LatestCreatedInvoicesTable.vue?vue&type=template&id=2fbf257a&scoped=true&"
import script from "./LatestCreatedInvoicesTable.vue?vue&type=script&lang=ts&"
export * from "./LatestCreatedInvoicesTable.vue?vue&type=script&lang=ts&"
import style0 from "./LatestCreatedInvoicesTable.vue?vue&type=style&index=0&id=2fbf257a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbf257a",
  null
  
)

export default component.exports